import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderServiceStep } from '../remote-action-builder-steps';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { IMSId, IMSObject } from 'src/app/_model/ims-object';
import { EMP_IMSAPPSTATUS } from 'src/app/_model/employee';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';

@Injectable()
export class TeamRemoteActionBuilderServiceStep
  implements GenericRemoteActionBuilderServiceStep
{
  constructor(
    private employeeService: EmployeeService,
    private clientStateService: ClientStateService,
    private logger?: LoggingService,
  ) {}

  public async getDataValues(): Promise<{ key: string; value: any }[]> {
    this.logger.log(this.constructor.name, '- Providing Employee Data');
    const teamIds = this.employeeService.getTeamIDs();
    this.logger.log(this.constructor.name, '- TeamIds:', teamIds);
    this.logger.log(
      this.constructor.name,
      '- TeamIds mapped:',
      teamIds.map((id: IMSId) => {
        return id.imsId;
      }),
    );
    const me = this.employeeService.me$.getValue();
    const currentLeader =
      this.clientStateService.theState.getValue().currentTeamLeader;
    return [
      {
        key: 'emps',
        value: teamIds
          .filter((id) => {
            const emp = this.employeeService.getEmployeeById(id);
            return (
              IMSObject.equals(me.id, id) ||
              ((currentLeader == undefined ||
                IMSObject.equals(me.id, currentLeader)) &&
                emp.imsappstatus == EMP_IMSAPPSTATUS.PASSIVE)
            );
          })
          .map((id: IMSId) => {
            return id.imsId;
          })
          .join(';'),
      },
    ];
  }
}
